import axios from "axios";
import { Config } from "../../server-config";

export const getInstanceUrl = (appCode) => {
  // console.log(`${Config.GET_AUTH_URL()}`);
  return axios.get(
    `${Config.GET_AUTH_URL()}?appCode=${appCode}`
  );
};

export const getSsoConfiguration = () => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  return axios.get(
    `https://${host}/${context}/teamsSSOConfig.do?method=getTeamsSSOConfig`,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
      },
    }
  );
};

export const login = (username, password) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const password64 = btoa(password);
  const postdata = { j_username: username, j_password: password64 };

  return axios.post(
    `https://${host}/${context}/j_acegi_security_check.do?source=mobile`,
    postdata,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
      },
    }
  );
};


export const refreshTokenGenerator = (token) => {
    const host = localStorage.getItem("host");
    const context = localStorage.getItem("context");
    return axios.get(
      `https://${host}/${context}/outlook/refreshToken.action`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": `${token}`
        },
      }
      ).catch((error) => {
        if (error) {
          return error.response;
        }
      });
  };

export const refreshTokenGeneratorForBotSection = (res) => {
    return axios.get(
      `https://${res.host}/${res.context}/outlook/refreshToken.action`,
      {
        headers: {
          "content-type": "application/json",
          "originated": "teams",
          "post-type": "ajax",
          "outlookauth": `${res.token}`
        },
      }
    ).catch((error) => {
      if (error) {
        return error.response;
      }
    });
};
